<template>
    <v-card class="panelBlock invites-someone " data-qe-id="InviteSomeOne_Invites">
        <h3>{{ networkConstants.SEND }} {{ communityType }} {{ networkConstants.INVITIES }}</h3>
        <v-layout row wrap class="invites-someone__title">
            <v-flex xs12 class="search-people">
                <v-btn
                    class="primary_btn transparent small"
                    :disabled="bulkInviteOption"
                    data-qe-id="hide_bulk-invite_btn"
                    @click="searchPeopleByName()"
                >
                    {{ networkConstants.SEARCH_PROFILE }}
                </v-btn>
                <v-flex tag="span">{{ 'upto 15 people allowed' }}</v-flex>
                <v-btn
                    class="primary_btn transparent small"
                    @click="displayBulkInvite()"
                    data-qe-id="show_bulk-invite_btn"
                    v-if="currentCommunityView === userRoles.ADMIN"
                >
                    {{ networkConstants.BULK_INVITE }}
                </v-btn>
            </v-flex>
        </v-layout>
        <v-flex class="error-msg" pl-3 v-if="isError">
            <span data-qe-id="InviteSomeOne_Error"> {{ errorDescription }} </span>
        </v-flex>
        <v-flex class="relative-position search-parent" v-if="!bulkInviteOption">
            <v-flex width="100%">
                <v-text-field
                    data-qe-id="invite_someone_people_search"
                    placeholder="Search for people by name"
                    append-icon="search"
                    slot="activator"
                    single-line
                    small
                    outline
                    clearable
                    v-model="peopleSearchText"
                    @keyup="getInviteesData()"
                    @click:clear="clearPeopleSearch()"
                >
                </v-text-field>
            </v-flex>
            <v-flex class="invites-someone__body inner-scrollbar search-result" v-if="isSearchMembers">
                <status-overlay :action="getMembersAction"></status-overlay>
                <v-flex
                    class="invites-someone__body__list-item"
                    v-for="(invitee, i) in inviteeList.searchResults"
                    :key="i"
                >
                    <v-avatar class="invites-someone__body__list-item__avatar">
                        <img
                            class="dialog-box__img-format"
                            data-qe-id="InviteSomeOne_Image"
                            align-center
                            :src="invitee.profileImageUrl"
                            :onerror="imageErrorFallback(invitee.fallbackProfileImageUrl)"
                        />
                    </v-avatar>
                    <v-flex
                        tag="strong"
                        class="invites-someone__body__list-item__name"
                        data-qe-id="InviteSomeOne_ListItemName"
                        >{{ preferredName(invitee) }}</v-flex
                    >
                    <v-flex v-for="(chapter, i) in invitee.chapters" :key="i">
                        <v-flex small v-if="chapter.isPrimary" :data-qe-id="'InviteSomeOne_Name' + i">{{
                            chapter.name
                        }}</v-flex>
                    </v-flex>
                    <v-btn icon @click="addMemberToList(invitee)" data-qe-id="add-members-to-list_btn">
                        <v-icon>fas fa-plus</v-icon>
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex
            class="invites-someone__body inner-scrollbar invites-someone-result"
            v-if="addedMembersList1.length > 0 && !bulkInviteOption"
        >
            <v-flex class="invites-someone__body__list-item" v-for="(addedinvitee, i) in addedMembersList1" :key="i">
                <v-avatar class="invites-someone__body__list-item__avatar">
                    <img
                        :data-qe-id="'InviteSomeOne_addedinvitee' + i"
                        class="dialog-box__img-format"
                        align-center
                        :src="addedinvitee.profileImageUrl"
                        :onerror="imageErrorFallback(addedinvitee.fallbackProfileImageUrl)"
                    />
                </v-avatar>
                <v-flex
                    tag="strong"
                    class="invites-someone__body__list-item__name"
                    :data-qe-id="'InviteSomeOne_PreferredName' + i"
                    >{{ preferredName(addedinvitee) }}</v-flex
                >

                <v-flex
                    tag="small"
                    class="invites-someone__body__list-item__info"
                    v-for="(chapter, j) in addedinvitee.chapters"
                    :key="j"
                >
                    <span v-if="chapter.isPrimary" :data-qe-id="'InviteSomeOne_PrimaryChapterName' + i">
                        {{ chapter.name }}
                    </span>
                </v-flex>
                <v-btn
                    icon
                    @click="deleteMemberToList(addedinvitee.id)"
                    :data-qe-id="'delete-members-from-list_btn' + i"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-flex>
        </v-flex>
        <v-flex class="relative-position search-parent" v-if="bulkInviteOption">
            <v-flex tag="h4" width="100%">
                {{ networkConstants.PASTE_EMAIL_ADDRESS }}
            </v-flex>
            <v-flex tag="small" width="100%"> {{ networkConstants.ADDRESS_ASSOCIATION }} </v-flex><br />
            <v-flex sm12 width="100%">
                <v-textarea
                    data-qe-id="bulk_invite_email_address"
                    placeholder="Paste Email Address"
                    slot="activator"
                    autofocus
                    outline
                    multi-line
                    scrollable
                    v-model="emailAddress"
                    :error="false"
                    :disabled="disableEmailAddressArea"
                    @keydown.enter="validateEmailAddress()"
                    @click:clear="clearBulkInvite()"
                >
                </v-textarea>
                <v-flex tag="small" width="100%">
                    {{ networkConstants.BULK_INVITE_WARNING_MESSAGE }}
                </v-flex>
            </v-flex>
            <v-flex v-if="members && members.length > 0">
                <v-chip close v-for="member in members" :key="member.id" @input="removeMember(member)">{{
                    member.name
                }}</v-chip>
            </v-flex>
            <v-flex v-if="invalidEmails && invalidEmails.length > 0">
                <v-chip close v-for="(email, i) in invalidEmails" :key="i" @input="removeInvalidEmail(email)">
                    <v-icon>error </v-icon>{{ email }}
                </v-chip>
            </v-flex>
        </v-flex>
        <v-layout v-if="displayForceJoin" row wrap class="invites-someone__action-item">
            <v-flex md6 tag="strong" data-qe-id="'InviteSomeOne_Force_Add_Community">{{ networkConstants.FORCE_ADD_COMMUNITY }}</v-flex>
            <v-flex md6 text-xs-right>
                <v-switch
                    data-qe-id="invite_someone_force_add"
                    class="invites-someone__action-item__switch-btn"
                    v-model="isForcetoAdd"
                ></v-switch>
            </v-flex>
        </v-layout>
        <v-flex xs12 text-xs-right pa-3>
            <v-btn
                class="primary_btn transparent"
                v-if="addedMembersList1.length > 0"
                small
                data-qe-id="cancel_invite"
                @click="resetValues()"
                >{{ appCommonConstants.CANCEL }}
            </v-btn>
            <v-btn
                data-qe-id="invite_someone_send"
                class="primary_btn"
                :loading="inviteInProgress"
                small
                :disabled="(addedMembersList1.length  === 0 || (bulkInviteOption && emailAddress.trim().length > 0))"
                @click="sendInvitetoMembers()"
                >{{ appCommonConstants.SEND }}</v-btn
            >
        </v-flex>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';
import { storeGetters } from '../../store/storeGetters.constant';
import { storeMutation } from '../../store/storeMutations.constant';
import { networkConstants } from '../ChapterPage/communityCommon.constant';
import StatusOverlay from '../StatusOverlay/StatusOverlay';
import { appCommonConstants, routerNames, userRoles } from '../appCommon.constants';
import { headerConstant } from '../../components/Header/header.constant';
import { imageErrorFallback } from '../../common/utils/utils';

export default {
    name: 'InviteSomeone',
    components: {
        StatusOverlay,
    },
    props: {
        displayForceJoin: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            disableEmailAddressArea: false,
            inviteInProgress: false,
            appCommonConstants,
            routerNames,
            networkConstants,
            headerConstant,
            userRoles,
            bulkInviteOption: false,
            peopleSearch: {
                searchText: null,
                searchResult: null,
            },
            searchObject: {
                search: '',
                orderBy: 'LastName asc',
                searchFilters: [],
                skip: 0,
                isInviteSearch: true,
            },
            addedMembersList1: [], // Search people by Name
            isSearchMembers: false,
            addedMembersList2: [], // Search people by Email
            isForceInvited: false,
            inviteesList: {
                InvitedPersonList: [],
                IsForceInvited: false,
            },
            isForcetoAdd: false,
            isError: false,
            errorDescription: '',
            peopleSearchText: '',
            emailAddress: '',
            invalidEmails: [],
            timeoutForTypeAhead: null,
        };
    },
    methods: {
        ...mapActions({
            getInviteesList: `network/${storeAction.getInviteesList}`,
            sendInviteesList: `network/${storeAction.sendInviteesList}`,
            verifyEmailExitsinDB: `network/${storeAction.verifyEmailExitsinDB}`,
        }),
        ...mapMutations({
            clearVerifiedMembers: `network/${storeMutation.clearVerifiedMembers}`,
        }),
        imageErrorFallback,
        getInviteesData() {
            if (this.peopleSearchText && this.peopleSearchText.length < 3) {
                this.inviteeList.searchResults = null;
                this.isSearchMembers = false;
            }
            clearTimeout(this.timeoutForTypeAhead);
            this.timeoutForTypeAhead = setTimeout(() => {
                if (this.peopleSearchText.length > 2) {
                    this.searchObject.search = this.peopleSearchText;
                    this.getInviteesList(JSON.parse(JSON.stringify(this.searchObject)));
                    this.isSearchMembers = true;
                } else if (!this.peopleSearchText) {
                    this.clearPeopleSearch();
                }
            }, 1500);
        },
        addMemberToList(objInvitee) {
            if (this.addedMembersList1.length < 15) {
                if (this.addedMembersList1.length > 0) {
                    const duplicaterecord = this.addedMembersList1.some(item => item.id === objInvitee.id);
                    if (!duplicaterecord) {
                        this.addedMembersList1.push(objInvitee);
                        this.clearPeopleSearch();
                        this.peopleSearchText = '';
                        this.isError = false;
                    } else {
                        this.isError = true;
                        this.errorDescription = 'You already added this member';
                        this.clearPeopleSearch();
                        this.peopleSearchText = '';
                    }
                } else {
                    this.addedMembersList1.push(objInvitee);
                    this.clearPeopleSearch();
                    this.isError = false;
                }
            } else {
                this.isError = true;
                this.errorDescription = 'You cannot add more than 15 people';
                this.isSearchMembers = false;
            }
        },
        deleteMemberToList(objInviteeId) {
            const invitee = this.addedMembersList1.find(item => item.id === objInviteeId);
            if (invitee) {
                this.addedMembersList1.splice(this.addedMembersList1.indexOf(invitee), 1);
            }
        },
        sendInvitetoMembers() {
            if (!this.error) {
                this.inviteesList.CommunityId = this.$route.params.communityId;
                this.inviteesList.IsForceInvited = this.isForcetoAdd;
                const sendPersonList = this.addedMembersList1.map(person => ({
                    PersonId: person.id,
                    Email: person.email,
                    FirstName: person.firstName,
                    LastName: person.lastName,
                    RecordTypeName: person.roleForSearch,
                }));
                this.inviteesList.InvitedPersonList = [];
                this.inviteesList.InvitedPersonList.push(...sendPersonList);
                this.inviteInProgress = true;
                this.sendInviteesList(this.inviteesList)
                    .then((data) => {
                        this.inviteInProgress = false;
                        this.$emit('onInviteSomeoneSuccess', data);
                        this.resetValues();
                    })
                    .catch((err) => {
                        this.inviteInProgress = false;
                        this.isError = false;
                        this.errorDescription = '';
                        let errorMessage = '';
                        this.invalidEmails = [];
                        const responseErr = err.response.data.message.toLowerCase();
                        const singleMemberError = this.networkConstants.SINGLE_MEMBER_INVITE_ERROR;
                        const bulkInviteErr = this.networkConstants.BULK_INVITE_ERROR;
                        if (responseErr) {
                            // eslint-disable-next-line no-nested-ternary
                            errorMessage = responseErr === singleMemberError.toLowerCase() ? singleMemberError : responseErr === bulkInviteErr.toLowerCase() ? bulkInviteErr : this.networkConstants.ERROR_WHILE_INVITING;
                        }
                        this.$emit('onInviteSomeoneFail', errorMessage);
                        this.resetValues();
                    });
            }
        },
        clearPeopleSearch() {
            this.inviteeList.searchResults = null;
            this.isSearchMembers = false;
            this.peopleSearchText = '';
        },
        resetValues() {
            this.addedMembersList1 = [];
            this.emailAddress = '';
            this.invalidEmails = null;
            this.bulkInviteOption = false;
            this.inviteesList = [];
            this.clearVerifiedMembers();
            this.isError = false;
            this.errorDescription = '';
            this.invalidEmails = [];
        },
        removeMember(member) {
            this.members.splice(this.members.indexOf(member), 1);
            this.deleteMemberToList(member.Id);
            if (this.members.length <= 15) {
                this.isError = false;
                this.errorDescription = '';
            }
        },
        removeInvalidEmail(email) {
            this.invalidEmails.splice(this.members.indexOf(email), 1);
            this.IsError = false;
            this.errorDescription = '';
            this.emailAddress = '';
        },
        displayBulkInvite() {
            this.bulkInviteOption = true;
        },
        searchPeopleByName() {
            this.bulkInviteOption = false;
        },
        verifyEmailAddress(emails) {
            const expression = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
            return emails.match(expression);
        },
        clearBulkInvite() {
            this.emailAddress = '';
            this.IsError = false;
            this.errorDescription = '';
        },
        preferredName(invitee) {
            let name = null;
            if (invitee.preferredName) {
                name = `${invitee.preferredName} ${invitee.lastName}`;
            } else {
                name = `${invitee.firstName} ${invitee.lastName}`;
            }
            return name;
        },
       async validateEmailAddress() {          
            const existingMembers = this.members.length;
            this.disableEmailAddressArea = true;
            this.isError = false;
            this.errorDescription = '';
            const validEmails = { emailIds: this.verifyEmailAddress(this.emailAddress) };
            const tokens = this.emailAddress.split(/[\s,;\t\n]+/).filter(item => item !== '');
            if (!validEmails.emailIds || validEmails.emailIds.length !== tokens.length) {
                if (!validEmails.emailIds && tokens.length > 0) {
                    this.invalidEmails = tokens;
                } else {
                    this.invalidEmails = tokens.filter(i => !validEmails.emailIds.includes(i));
                }
                if (this.invalidEmails.length > 0) {
                    this.isError = true;
                    this.errorDescription = `You have entered ${this.invalidEmails.length} invalid email address`;
                    this.emailAddress = '';
                }
            }
            if (validEmails.emailIds && existingMembers + validEmails.emailIds.length <= 15) {
                await this.verifyEmailExitsinDB(validEmails);
            } else if (validEmails.emailIds && existingMembers + validEmails.emailIds.length > 15 && !this.isError) {
                this.isError = true;
                this.errorDescription = 'You cannot add more than 15 people';
            }
            if (this.members.length !== existingMembers + validEmails.emailIds.length && !this.isError) {
                if (this.members.length > 0) {
                    const verifiedEmails = this.members.map(i => i.email);
                    this.invalidEmails = tokens.filter(i => !verifiedEmails.includes(i));
                } else {
                    this.invalidEmails = validEmails.emailIds;
                }
                if (this.invalidEmails.length > 0 && !this.isError) {
                    this.isError = true;
                    this.errorDescription = `You have entered ${this.invalidEmails.length} invalid email address`;
                    this.emailAddress = '';
                }
            }
            if (this.members.length > 0 && this.members.length <= 15) {
                this.addedMembersList1 = this.members;
                this.emailAddress = '';
            } else if (!this.isError) {
                this.isError = true;
                this.errorDescription = 'You cannot add more than 15 people';
            }
            this.disableEmailAddressArea = false;
        },
    },
    computed: {
        ...mapGetters({
            inviteeList: `network/${storeGetters.inviteeList}`,
            returnInviteesList: `network/${storeGetters.returnInviteesList}`,
            members: `network/${storeGetters.verifiedMembers}`,
            currentCommunityView: `${storeGetters.currentCommunityView}`,
        }),
        ...mapState('actionState', ['actions']),
        communityType() {
            return this.$route.name;
        },
        getMembersAction() {
            return this.actions[storeAction.getInviteesList];
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.chip {
    display: inline-block;
    font-weight: bold;
}

.smart-input .input {
    font: inherit;
    resize: vertical;
}

.smart-input .output {
    overflow-wrap: break-word;
    word-break: break-all;
}

.filter-options {
    background-color: $ypo-extra-light-gray;

    &__typeAhead {
        margin-top: 20px;

        &-input {
            background-color: $white;
        }
    }
}

.invites-someone {
    border: 0 !important;
    z-index: 1;

    h3 {
        color: $white;
        background: $ypo_blue;
        font-size: 14px;
        padding: 10px 15px;
        letter-spacing: 0;
        font-weight: 500;
    }

    &__title {
        padding: 10px 5px 5px 15px;
        border-bottom: 1px solid $ypo-medium-gray;
        margin-bottom: 10px;
        font-size: 14px;
        text-transform: uppercase;
        color: rgba($ypo_blue, 0.61);
        align-items: center;
        font-weight: 600;

        .v-btn {
            margin: 0 -5px 0 0px;
        }
    }

    &__body {
        max-height: 350px;
        padding: 15px;
        overflow-y: auto;

        &__list-item {
            position: relative;
            padding: 20px 10px 20px 75px;
            border-bottom: 1px $ypo-medium-gray solid;
            align-items: center;
            min-height: 84px;

            &:hover {
                background: $ypo-open-blue-gray;

                .v-btn {
                    opacity: 1;
                    visibility: visible;
                }
            }

            &__avatar {
                position: absolute;
                left: 10px;
                top: 16px;
            }

            &__name {
                font-size: 15px;
                color: $ypo-dark-background-gray;
                font-weight: 600;
                display: block;
            }

            &__info {
                span {
                    color: $ypo-blue-medium-background;
                    display: block;
                    text-align: left;
                    font-size: 12px;
                }
            }

            small {
                display: block;
                color: $ypo-dark-background-gray;
            }

            .v-btn {
                position: absolute;
                right: 10px;
                z-index: 2;
                top: 16px;
                opacity: 0;
                visibility: hidden;
                transition: 0.5s all ease;

                .v-icon {
                    color: $ypo_blue !important;
                }
            }
        }

        &.invites-someone-result {
            padding-top: 0;
        }

        &.search-result {
            width: 100%;
            background: $white;
            z-index: 1;
            border: 1px $ypo-medium-gray solid;
            border-radius: 0px 0px 3px 3px;
            box-shadow: 0 1px 3px 0 rgba($black, 0.18);
            border: 1px solid rgba($ypo-gray, 0.4) !important;
            padding: 0 0px;
            margin-top: -28px;
            margin-bottom: 40px;

            @include breakpoint(xs) {
                padding: 0px;

                .overlay {
                    position: inherit;
                }
            }
        }

        .overlay {
            top: 56px;
            border: 1px solid $ypo-medium-gray;
            border-radius: 0 0 3px 3px;
            padding: 50px;
            z-index: 10;
        }
    }

    &__action-item {
        padding: 10px 15px;
        border-bottom: 1px solid $ypo-medium-gray;
        border-top: 1px solid $ypo-medium-gray;
        align-items: center;

        strong {
            color: $ypo_blue;
            font-weight: 600;
            text-transform: uppercase;
        }

        &__switch-btn {
            display: inline-block;
            top: 13px;
            position: relative;
        }
    }

    .search-parent {
        margin: 15px 15px 0 15px;
    }

    .search-people {
        display: inherit;

        .v-btn {
            display: block;
            padding: 5px 10px;
        }

        span {
            font-size: 12px;
            text-transform: capitalize;
            color: $ypo-dark-background-gray;
            font-weight: 500;
            padding: 3px 0 0 22px;
        }
    }

    .error-msg {
        color: $ypo-red;
        position: relative;
        left: 0;
        top: 5px;
        font-size: 13px;
    }

    .search-parent {
        h4 {
            color: $ypo-blue;
            font-size: 13.5px;
        }

        small {
            font-size: 12px;
        }

        .material-icons {
            margin: 0 5px 0 0;
            color: $ypo-red;
            font-size: 22px;
        }
    }
}
</style>
